import { useState, useEffect, useMemo } from 'react';

export const usePageManager = (items, itemsPerPage = 3) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [showFilters, setShowFilters] = useState(false);
  const [viewMode, setViewMode] = useState("grid");

  const totalPages = Math.ceil(items.length / itemsPerPage);

  // Reset page when items change
  useEffect(() => {
    if (currentPage > totalPages && items.length > 0) {
      setCurrentPage(1);
    }
  }, [items, currentPage, totalPages]);

  // Current page items
  const currentItems = useMemo(() => {
    return items.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  }, [items, currentPage, itemsPerPage]);

  // Pagination functions
  const goToFirstPage = () => setCurrentPage(1);
  const goToPreviousPage = () => setCurrentPage(prev => Math.max(1, prev - 1));
  const goToNextPage = () => setCurrentPage(prev => Math.min(totalPages, prev + 1));
  const goToLastPage = () => setCurrentPage(totalPages);

  // Filter functions
  const resetFilters = () => {
    setSearchTerm("");
    setFilterStatus("all");
    setCurrentPage(1);
  };

  const toggleViewMode = () => {
    setViewMode(prev => prev === "grid" ? "list" : "grid");
  };

  const toggleFilters = () => {
    setShowFilters(prev => !prev);
  };

  return {
    // State
    currentPage,
    totalPages,
    searchTerm,
    filterStatus,
    showFilters,
    viewMode,
    currentItems,
    
    // Setters
    setCurrentPage,
    setSearchTerm,
    setFilterStatus,
    setShowFilters,
    setViewMode,
    
    // Functions
    goToFirstPage,
    goToPreviousPage,
    goToNextPage,
    goToLastPage,
    resetFilters,
    toggleViewMode,
    toggleFilters
  };
};